import React from 'react'

const Privacypolicy = () => {
    return (
        <div className='privacy_container'>
            <h1 className='terms_h_tag'>Privacy Policy</h1>

            <h2 className='terms_h_tag'>1. Introduction</h2>
            <p>Welcome to Our “B_Barna Educational Institute”. Your privacy is important to us, and this Privacy Policy explains how we collect, use, disclose, and protect your information when you use our educational application and website.</p>

            <h2 className='terms_h_tag'>2. Information We Collect</h2>
            <p>We collect the following types of information:</p>
            <ul>
                <li><strong>Personal Information:</strong> Name, email address, phone number, profile picture, etc.</li>
                <li><strong>Usage Data:</strong> IP address, browser type, device information, pages visited, time spent on our site/app.</li>
                <li><strong>Cookies and Tracking Technologies:</strong> To enhance user experience and analyze trends.</li>
            </ul>

            <h2 className='terms_h_tag'>3. How We Use Your Information</h2>
            <p>We use your information to:</p>
            <ul>
                <li>Provide and improve our services.</li>
                <li>Personalize user experience.</li>
                <li>Respond to inquiries and customer support requests.</li>
                <li>Analyze usage and improve our app and website.</li>
                <li>Send updates, promotions, or educational content (only with user consent).</li>
            </ul>

            <h2 className='terms_h_tag'>4. Information Sharing and Disclosure</h2>
            <p>We do not sell or rent user data. However, we may share information with:</p>
            <ul>
                <li><strong>Service Providers:</strong> Third-party partners who assist in app/website functionality.</li>
                <li><strong>Legal Authorities:</strong> If required by law or to protect our rights.</li>
            </ul>

            <h2 className='terms_h_tag'>5. Cookies and Tracking Technologies</h2>
            <p>We use cookies to:</p>
            <ul>
                <li>Remember user preferences.</li>
                <li>Analyze app/website traffic.</li>
                <li>Improve user experience. Users can disable cookies from browser settings.</li>
            </ul>

            <h2 className='terms_h_tag'>6. Data Security</h2>
            <p>We take appropriate security measures, including encryption and secure storage, to protect user data. However, no method of transmission over the internet is 100% secure.</p>

            <h2 className='terms_h_tag'>7. User Rights</h2>
            <p>Users have the right to:</p>
            <ul>
                <li>Access, update, or delete their personal data.</li>
                <li>Opt out of marketing communications.</li>
                <li>Request data portability.</li>
            </ul>

            <h2 className='terms_h_tag'>8. Children's Privacy</h2>
            <p>If our app/website is used by children under 13, we comply with COPPA regulations. Parents can request the deletion of their child's data.</p>

            <h2 className='terms_h_tag'>9. Changes to This Privacy Policy</h2>
            <p>We may update this policy periodically. Users will be notified of any significant changes.</p>

            <h2 className='terms_h_tag'>10. Contact Us</h2>
            <p>If you have any questions about this Privacy Policy, please contact us at:</p>
            <ul>
                <li><strong>Gmail:</strong> bbarna.official@gmail.com</li>
                <li><strong>Phone:</strong> 7001739646</li>
            </ul>
        </div>
    )
}

export default Privacypolicy